<template lang="pug">
  span
    i.fa.fa-star 
</template>



<script>
  export default {
    name: 'star',

    components: {

    },

    props: {
    },

    data() {
      return {

      }
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
  }
</script>



<style lang="scss">
  .fa-star, 
  .fa-star-half {
    color: #F7CA18;
  }
</style>